<template>
    <v-card class="py-8" color="primary darken-2">
        <div style="display:flex; align-items:center">
            <v-icon class="mr-2" color="secondary lighten-1">mdi-file-document-outline</v-icon>
            <h2 class="title-page" style="display:inline; font-weight: bold;font-size: 24px;line-height: 28px;">Consulta de dados observados</h2>
        </div>
        <h4 class="mt-2 subtitle-page" style="font-style: normal;font-weight: 300;font-size: 16px;line-height: 20px;">Dados medidos por instrumento nas estações e classificados de acordo com o controle de qualidade.</h4>
        <selection-data-type
            :types="types"
            :stations="stations"
            :searchResult="searchResult"
            dataType="observed"
            @changeDataType="changeDataType($event)"
            @searchStationData="searchStationData($event)"
        >
        </selection-data-type>
        <div v-show="searchResult">
            <search-result
                :searchResult="searchResult"
                :type="type"
                :types="types"
                :loadingData="loadingData"
                :loadingOtherPeriod="loadingOtherPeriod"
                @applyPeriod="applyPeriod($event)"
            >
            </search-result>
        </div>
    </v-card>
</template>

<script>
import moment from "moment";
import SearchResult from './SearchResult.vue'
import SelectionDataType from "./SelectionDataType.vue"
export default {
    name:"ObservedData",
    props: {
        stations:{
            type: Array,
            required: true,
        },
        loadingOtherPeriod:{
            type: Boolean
        },
        loadingData: {
            type: Boolean,
            default: false,
        },
        searchResult:{
            type: Object
        },
    },
    components:{
        SelectionDataType,
        SearchResult,
    },
    data(){
      return{
        types: [],
        type: 'observado'
      }
    },
    created(){
      this.type = 'observado'
        this.initialize();
    },
    methods:{
        initialize(){
            const intervalType = this.createIntervalType();
            this.types = [ intervalType ];
        },

        createIntervalType(){
            const intervalType = {
                icon: "mdi-update",
                title: "Frequências de 15 minutos",
                value: "observado",
            };
            const startDate = (moment.tz('America/Sao_Paulo').hours() > 0 ? moment.tz('America/Sao_Paulo').startOf("day") : moment.tz('America/Sao_Paulo').startOf("day").subtract(2, 'hours'));
            const finalDate = moment.tz('America/Sao_Paulo').startOf("hour").add(1, 'hour');
            const subtitle = `De ${startDate.format("DD/MM/YYYY HH:mm")} a ${finalDate.format("DD/MM/YYYY HH:mm")}`;
            const date_start = startDate.utc().format();
            const date_end = finalDate.utc().format();
            return { ...intervalType, subtitle, date_start, date_end };
        },

        changeDataType(dataType){
          this.type = 'observado'
          this.$emit("changeDataType", dataType);
        },

        searchStationData(searchStationDataParams){
            this.$emit("searchStationData", { ...searchStationDataParams });
        },

        applyPeriod(periodSelected){
            this.$emit("applyPeriod", periodSelected);
        }
    }
}
</script>

<style>

</style>
